import { jsx, jsxs } from 'react/jsx-runtime';
import { createContext, useContext, useMemo } from 'react';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$a =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$a = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$9 = fails$a;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$9(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$8 = fails$a;

var functionBindNative = !fails$8(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$6 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$6.bind(call$6) : function () {
  return call$6.apply(call$6, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var call$5 = FunctionPrototype$1.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$5, call$5);

var functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$5.apply(fn, arguments);
  };
};

var uncurryThis$9 = functionUncurryThis;

var toString$2 = uncurryThis$9({}.toString);
var stringSlice$1 = uncurryThis$9(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$2(it), 8, -1);
};

var uncurryThis$8 = functionUncurryThis;
var fails$7 = fails$a;
var classof$2 = classofRaw$1;

var $Object$3 = Object;
var split = uncurryThis$8(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$7(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$3('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$2(it) == 'String' ? split(it, '') : $Object$3(it);
} : $Object$3;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$5 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (isNullOrUndefined$1(it)) throw $TypeError$5("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$3 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$b = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$a = isCallable$b;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$5 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$a(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$a(it);
};

var global$9 = global$a;
var isCallable$9 = isCallable$b;

var aFunction = function (argument) {
  return isCallable$9(argument) ? argument : undefined;
};

var getBuiltIn$2 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
};

var uncurryThis$7 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$7({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$8 = global$a;
var userAgent = engineUserAgent;

var process = global$8.process;
var Deno = global$8.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$6 = fails$a;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$6(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$1 = getBuiltIn$2;
var isCallable$8 = isCallable$b;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$1('Symbol');
  return isCallable$8($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$2(it));
};

var $String$3 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$7 = isCallable$b;
var tryToString = tryToString$1;

var $TypeError$4 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$7(argument)) return argument;
  throw $TypeError$4(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var call$4 = functionCall;
var isCallable$6 = isCallable$b;
var isObject$4 = isObject$5;

var $TypeError$3 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$6(fn = input.toString) && !isObject$4(val = call$4(fn, input))) return val;
  if (isCallable$6(fn = input.valueOf) && !isObject$4(val = call$4(fn, input))) return val;
  if (pref !== 'string' && isCallable$6(fn = input.toString) && !isObject$4(val = call$4(fn, input))) return val;
  throw $TypeError$3("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$7 = global$a;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$2(global$7, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$7[key] = value;
  } return value;
};

var global$6 = global$a;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.28.0',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.28.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible = requireObjectCoercible$2;

var $Object$1 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function (argument) {
  return $Object$1(requireObjectCoercible(argument));
};

var uncurryThis$6 = functionUncurryThis;
var toObject$1 = toObject$2;

var hasOwnProperty = uncurryThis$6({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$1(it), key);
};

var uncurryThis$5 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$1 = uncurryThis$5(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1(++id + postfix, 36);
};

var global$5 = global$a;
var shared$2 = shared$3.exports;
var hasOwn$7 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = global$5.Symbol;
var WellKnownSymbolsStore = shared$2('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$3 = function (name) {
  if (!hasOwn$7(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$7(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$3 = functionCall;
var isObject$3 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$2 = wellKnownSymbol$3;

var $TypeError$2 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$2('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$3(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw $TypeError$2("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$4 = global$a;
var isObject$2 = isObject$5;

var document$1 = global$4.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$2(document$1) && isObject$2(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$5 = fails$a;
var createElement = documentCreateElement;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$5(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$6 = descriptors;
var call$2 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$6 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$6(O, P)) return createPropertyDescriptor$1(!call$2(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$5 = descriptors;
var fails$4 = fails$a;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$4(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$1 = isObject$5;

var $String$2 = String;
var $TypeError$1 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$4 = function (argument) {
  if (isObject$1(argument)) return argument;
  throw $TypeError$1($String$2(argument) + ' is not an object');
};

var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var anObject$3 = anObject$4;
var toPropertyKey = toPropertyKey$2;

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject$3(O);
  P = toPropertyKey(P);
  anObject$3(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$3(O);
  P = toPropertyKey(P);
  anObject$3(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$2 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$2 = descriptors;
var hasOwn$5 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$5(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$4 = functionUncurryThis;
var isCallable$5 = isCallable$b;
var store$1 = sharedStore;

var functionToString = uncurryThis$4(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$5(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var global$3 = global$a;
var isCallable$4 = isCallable$b;

var WeakMap$1 = global$3.WeakMap;

var weakMapBasicDetection = isCallable$4(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$2 = global$a;
var isObject = isObject$5;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$2;
var hasOwn$4 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$2.TypeError;
var WeakMap = global$2.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$4(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$1(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$4(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$4(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$3 = functionUncurryThis;
var fails$3 = fails$a;
var isCallable$3 = isCallable$b;
var hasOwn$3 = hasOwnProperty_1;
var DESCRIPTORS$1 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule = internalState;

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String$1 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;
var stringSlice = uncurryThis$3(''.slice);
var replace = uncurryThis$3(''.replace);
var join = uncurryThis$3([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$3(function () {
  return defineProperty$1(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (stringSlice($String$1(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String$1(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$3(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS$1) defineProperty$1(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$3(options, 'arity') && value.length !== options.arity) {
    defineProperty$1(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$3(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$1) defineProperty$1(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$3(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$3(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

var isCallable$2 = isCallable$b;
var definePropertyModule$1 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$2 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$2(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var uncurryThis$2 = functionUncurryThis;
var hasOwn$2 = hasOwnProperty_1;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var push = uncurryThis$2([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$2(hiddenKeys$1, key) && hasOwn$2(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$2(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$2;
var uncurryThis$1 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$2 = anObject$4;

var concat$1 = uncurryThis$1([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$2(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$1 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$1(target, key) && !(exceptions && hasOwn$1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$2 = fails$a;
var isCallable$1 = isCallable$b;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$1(detection) ? fails$2(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$a;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$2;
var defineBuiltIn$1 = defineBuiltIn$2;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn$1(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var DESCRIPTORS = descriptors;
var uncurryThis = functionUncurryThis;
var call$1 = functionCall;
var fails$1 = fails$a;
var objectKeys = objectKeys$1;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$2;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$1(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call$1(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

var wellKnownSymbol$1 = wellKnownSymbol$3;

var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable = isCallable$b;
var classofRaw = classofRaw$1;
var wellKnownSymbol = wellKnownSymbol$3;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var classof = classof$1;

var $String = String;

var toString = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var anObject$1 = anObject$4;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call = functionCall;
var hasOwn = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R)
    ? call(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$2;
var anObject = anObject$4;
var $toString = toString;
var fails = fails$a;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

// 默认属性
const DEFAULT_ICON_CONFIGS = {
  size: "24px",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rtl: false,
  theme: "stroke",
  colors: {
    stroke: {
      fill: "#333",
      background: "transparent"
    },
    fill: {
      fill: "#333",
      background: "#FFF"
    },
    twoTone: {
      fill: "#333",
      twoTone: "#2F88FF"
    },
    multiColor: {
      outStrokeColor: "#333",
      outFillColor: "#2F88FF",
      innerStrokeColor: "#FFF",
      innerFillColor: "#43CCF8"
    }
  },
  prefix: "zy"
};
function guid() {
  return "icon-" + ((1 + Math.random()) * 0x100000000 | 0).toString(16).substring(1);
}
// 属性转换函数
function IconConverter(id, icon, config) {
  const colorProp = typeof icon.colors === "string" ? [icon.colors] : icon.colors || [];
  const colorsReality = [];
  const theme = icon.theme || config.theme;
  switch (theme) {
    case "stroke":
      colorsReality.push(typeof colorProp[0] === "string" ? colorProp[0] : "currentColor");
      colorsReality.push("none");
      colorsReality.push(typeof colorProp[0] === "string" ? colorProp[0] : "currentColor");
      colorsReality.push("none");
      break;
    case "fill":
      colorsReality.push(typeof colorProp[0] === "string" ? colorProp[0] : "currentColor");
      colorsReality.push(typeof colorProp[0] === "string" ? colorProp[0] : "currentColor");
      colorsReality.push("#FFF");
      colorsReality.push("#FFF");
      break;
  }
  return {
    size: icon.size || config.size,
    strokeWidth: icon.strokeWidth || config.strokeWidth,
    strokeLinecap: icon.strokeLinecap || config.strokeLinecap,
    strokeLinejoin: icon.strokeLinejoin || config.strokeLinejoin,
    colorsReality,
    id
  };
}
// 图标配置Context
const IconContext = /*#__PURE__*/createContext(DEFAULT_ICON_CONFIGS);
// 图标配置Provider
IconContext.Provider;
// 图标Wrapper
function IconWrapper(name, rtl, render) {
  return function Icon(props) {
    const {
        size,
        strokeWidth,
        strokeLinecap,
        strokeLinejoin,
        theme,
        colors,
        className
      } = props,
      extra = __rest(props, ["size", "strokeWidth", "strokeLinecap", "strokeLinejoin", "theme", "colors", "className"]);
    const ICON_CONFIGS = useContext(IconContext);
    const id = useMemo(guid, []);
    const svgProps = IconConverter(id, {
      size,
      strokeWidth,
      strokeLinecap,
      strokeLinejoin,
      theme,
      colors
    }, ICON_CONFIGS);
    const cls = [ICON_CONFIGS.prefix + "-icon"];
    cls.push(ICON_CONFIGS.prefix + "-icon" + "-" + name);
    if (rtl && ICON_CONFIGS.rtl) {
      cls.push(ICON_CONFIGS.prefix + "-icon-rtl");
    }
    if (className) {
      cls.push(className);
    }
    return jsx("span", Object.assign({}, extra, {
      className: cls.join(" "),
      style: {
        fontSize: "unset"
      }
    }, {
      children: render(svgProps)
    }));
  };
}

/* eslint-disable-next-line */
const CloudClips = IconWrapper('cloud-clips', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M6.5 16C4.5 16 3 14.3935 3 12.5C3 10.6065 4.5 9 6.5 9C6.5 7 8.4 4 12 4C15.6 4 17.5 7 17.5 9C19.5 9 21 10.6065 21 12.5C21 14.3935 19.4882 16 17.5 16",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M14 18L16 20M10 18L8 20C8.5 20.5 9.5 20.5 10 20C10.5 19.5 10.5 18.5 10 18ZM10 18L12 16M16 12L12 16M10 14L8 12C8.5 11.5 9.5 11.5 10 12C10.5 12.5 10.5 13.5 10 14ZM10 14L12 16",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const ZycamiEditor = IconWrapper('zycami-editor', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M9.95789 16C9.69123 16 9.46316 15.9014 9.27368 15.7041C9.09123 15.4993 9 15.2451 9 14.9417C9 14.8355 9.01053 14.7406 9.03158 14.6572C9.05263 14.5661 9.08772 14.4903 9.13684 14.4296L12.0632 10.0484H10C9.84561 10.0484 9.69123 10.037 9.53684 10.0142C9.38246 9.98388 9.25263 9.90043 9.14737 9.76387C9.04912 9.61972 9 9.38075 9 9.04694C9 8.69796 9.04561 8.4514 9.13684 8.30725C9.23509 8.16311 9.35789 8.07587 9.50526 8.04552C9.65965 8.01517 9.81404 8 9.96842 8H13.9053C14.1719 8 14.3965 8.10242 14.5789 8.30725C14.7684 8.51209 14.8632 8.76624 14.8632 9.0697C14.8632 9.17591 14.8526 9.27454 14.8316 9.36558C14.8105 9.44903 14.7754 9.5211 14.7263 9.58179L11.8 13.963H14.0526C14.207 13.963 14.3544 13.9782 14.4947 14.0085C14.6421 14.0389 14.7614 14.1261 14.8526 14.2703C14.9509 14.4068 15 14.6382 15 14.9644C15 15.3058 14.9509 15.5486 14.8526 15.6927C14.7614 15.8369 14.6421 15.9241 14.4947 15.9545C14.3474 15.9848 14.193 16 14.0316 16H9.95789Z",
      fill: props.colorsReality[1],
      className: "body",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ', jsx("path", {
      d: "M19 5V15M19 5H10M19 5L20.5 3.5M19 15H22M19 15V20",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M5 9V19H14M5 9L2 9M5 9V4",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const PanoramicSplit = IconWrapper('panoramic-split', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M21 19C21 12 21 12 21 5C16 7 8 7 3.00001 5C3.00008 12 2.99997 12 3.00001 19C4.72505 18.31 6.80718 17.858 9 17.6441M21 19C18.6569 16.2663 15 12 15 12L9 17.6441M21 19C17.725 17.69 13.163 17.2381 9 17.6441",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("circle", {
      cx: "9",
      cy: "11",
      r: "1",
      fill: props.colorsReality[1],
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const SmartHitchcock = IconWrapper('smart-hitchcock', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M13.5 5.5L15.6 3.74888C14.4976 3.26721 13.28 3 12 3C7.02944 3 3 7.02944 3 12C3 14.0261 3.6695 15.8958 4.79934 17.4M10.5 18.5L8.4 20.2511C9.50243 20.7328 10.72 21 12 21C16.9706 21 21 16.9706 21 12C21 9.97391 20.3305 8.10419 19.2007 6.6",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M12.0008 16C11.5263 16 11.1217 15.9445 10.7872 15.8336C10.4604 15.7226 10.192 15.5932 9.98194 15.4452C9.77188 15.2899 9.61239 15.1493 9.50347 15.0236C9.39455 14.8978 9.32842 14.8202 9.30508 14.7906C9.14949 14.6056 9.05224 14.4392 9.01334 14.2913C8.98222 14.1433 9.00556 13.9954 9.08336 13.8474C9.16894 13.6995 9.30897 13.5368 9.50347 13.3592C9.68241 13.1965 9.85746 13.1077 10.0286 13.0929C10.1998 13.0707 10.367 13.104 10.5304 13.1928C10.7016 13.2816 10.865 13.411 11.0206 13.5811C11.2073 13.7809 11.3668 13.9177 11.499 13.9917C11.6313 14.0583 11.783 14.0915 11.9542 14.0915C12.1642 14.0915 12.3354 14.0693 12.4676 14.025C12.5999 13.9732 12.6971 13.8992 12.7594 13.8031C12.8216 13.6995 12.8527 13.57 12.8527 13.4147C12.8527 13.289 12.7866 13.1928 12.6543 13.1262C12.5221 13.0522 12.347 12.9894 12.1292 12.9376C11.9191 12.8858 11.6819 12.8303 11.4173 12.7712C11.1528 12.7046 10.8922 12.6195 10.6355 12.516C10.4799 12.4568 10.3281 12.3828 10.1803 12.294C10.0325 12.2053 9.89247 12.1054 9.76021 11.9945C9.63573 11.8761 9.52681 11.7393 9.43345 11.5839C9.34009 11.4212 9.26619 11.2399 9.21173 11.0402C9.16505 10.8405 9.14171 10.6149 9.14171 10.3634C9.14171 9.91216 9.25841 9.50902 9.4918 9.15395C9.73298 8.79889 10.0597 8.5178 10.4721 8.31068C10.8922 8.10356 11.3668 8 11.8958 8C12.277 8 12.6038 8.02959 12.8761 8.08877C13.1484 8.14794 13.3701 8.21822 13.5413 8.29958C13.7202 8.38095 13.8563 8.45862 13.9497 8.53259C14.0431 8.59917 14.1014 8.64355 14.1248 8.66574C14.3815 8.88766 14.5215 9.07998 14.5449 9.24272C14.5682 9.39806 14.4749 9.62367 14.2648 9.91956C14.0314 10.2376 13.8019 10.4189 13.5763 10.4632C13.3507 10.5002 13.09 10.43 12.7944 10.2524C12.7321 10.208 12.6699 10.16 12.6077 10.1082C12.5454 10.049 12.4599 10.0009 12.3509 9.96394C12.2498 9.91956 12.0942 9.89736 11.8841 9.89736C11.8063 9.89736 11.7285 9.91216 11.6507 9.94175C11.5729 9.96394 11.5068 9.99723 11.4523 10.0416C11.3979 10.0786 11.3512 10.1267 11.3123 10.1859C11.2812 10.245 11.2656 10.3079 11.2656 10.3745C11.2656 10.5298 11.3279 10.6519 11.4523 10.7406C11.5768 10.822 11.7402 10.8849 11.9425 10.9293C12.1525 10.9736 12.3821 11.018 12.631 11.0624C12.88 11.1068 13.1328 11.166 13.3896 11.2399C13.5996 11.3065 13.8019 11.3916 13.9964 11.4951C14.1909 11.5987 14.362 11.7319 14.5099 11.8946C14.6577 12.0573 14.7744 12.2607 14.86 12.5049C14.9533 12.7416 15 13.0337 15 13.3814C15 13.8622 14.9028 14.2728 14.7083 14.613C14.5138 14.9459 14.2609 15.2159 13.9497 15.423C13.6463 15.6227 13.3195 15.767 12.9694 15.8558C12.6271 15.9519 12.3043 16 12.0008 16Z",
      fill: props.colorsReality[1],
      className: "body",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const LiveMasters = IconWrapper('live-masters', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M16 13L16 19L2 19L2 5L16 5L16 11M16 13L22 18L22 6L16 11M16 13L16 11",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M5.57795 9.46342L7.14018 10.4801L8.6972 8.35238C8.73161 8.30531 8.77703 8.26695 8.8297 8.24048C8.88236 8.21401 8.94074 8.2002 8.99998 8.2002C9.05921 8.2002 9.11759 8.21401 9.17025 8.24048C9.22292 8.26695 9.26834 8.30531 9.30275 8.35238L10.8598 10.4801L12.422 9.46342C12.4811 9.42503 12.5503 9.40395 12.6213 9.40269C12.6923 9.40143 12.7622 9.42004 12.8227 9.45631C12.8832 9.49259 12.9318 9.54502 12.9628 9.6074C12.9937 9.66978 13.0058 9.73952 12.9974 9.80836L12.3863 14.8796C12.3756 14.9679 12.3321 15.0493 12.2641 15.1084C12.196 15.1675 12.108 15.2002 12.0169 15.2002H5.98301C5.89191 15.2002 5.80397 15.1675 5.73589 15.1084C5.66781 15.0493 5.62432 14.9679 5.61366 14.8796L5.00253 9.80799C4.99427 9.73918 5.00635 9.6695 5.03735 9.60718C5.06835 9.54485 5.11696 9.49248 5.17746 9.45626C5.23796 9.42003 5.30782 9.40145 5.37878 9.40272C5.44974 9.40399 5.51885 9.42506 5.57795 9.46342Z",
      fill: props.colorsReality[1],
      className: "body",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const GestureControl = IconWrapper('gesture-control', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M8 4H4V8M8 20H4V16M20 8V4H16M20 16V20H16",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M7.26907 12C7.61773 11.6802 7.99508 11.6742 8.35029 12L9.46879 13.3073C9.7352 13.5519 10.0566 13.5519 10.2478 13.3511C10.378 13.2191 10.3165 12.8056 10.2892 12.5421L9.78314 8.6929C9.7352 8.34813 10.0021 8.01583 10.378 7.97199C10.7539 7.92768 11.1026 8.19121 11.1364 8.53598L11.6969 11.5641C11.7313 11.6458 11.7928 11.6518 11.7994 11.5581L11.9911 7.63322C11.9911 7.28246 12.2989 7 12.6813 7C13.0638 7 13.3645 7.282 13.3645 7.63322L13.358 11.5641C13.358 11.6079 13.3988 11.6209 13.4059 11.5705L14.0139 8.47967C14.0755 8.13491 14.4307 7.89029 14.8071 7.95306C15.183 8.01583 15.4221 8.36059 15.3606 8.6929L14.8136 12.3164C14.8136 12.3731 14.8273 12.423 14.8681 12.3288L15.682 10.3604C15.8117 10.0406 16.1941 9.84626 16.5428 9.95288C16.8914 10.072 17.0897 10.4421 16.9601 10.7744L15.5316 15.0186L15.5175 15.0814V15.0874C15.3237 15.6429 14.9418 16.1276 14.4269 16.4714C13.9121 16.8153 13.2911 17.0004 12.6536 17C11.7762 16.9957 10.9243 16.7293 10.2277 16.2412C9.48948 15.8337 7.26907 13.0714 7.26907 13.0714C6.91385 12.7705 6.90679 12.3198 7.26907 12Z",
      fill: props.colorsReality[1],
      className: "body",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const SmartTracking = IconWrapper('smart-tracking', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M8 4H4V8M8 20H4V16M20 8V4H16M20 16V20H16",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M9.55232 11.0716C8.90316 10.4085 8.53846 9.50916 8.53846 8.57143H7C6.99976 9.50617 7.25067 10.423 7.72541 11.2222C8.20014 12.0213 8.88048 12.672 9.69231 13.1034V17H14.3077L14.3085 13.1026C15.12 12.6712 15.8001 12.0205 16.2747 11.2216C16.7493 10.4226 17.0002 9.50595 17 8.57143H15.4615C15.4615 9.50916 15.0968 10.4085 14.4477 11.0716C13.7985 11.7346 12.9181 12.1071 12 12.1071C11.0819 12.1071 10.2015 11.7346 9.55232 11.0716Z",
      fill: props.colorsReality[1],
      className: "body",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ', jsx("path", {
      d: "M13.3598 7.57533C12.9992 7.20695 12.51 7 12 7C11.49 7 11.0008 7.20695 10.6402 7.57533C10.2795 7.9437 10.0769 8.44332 10.0769 8.96429C10.0769 9.48525 10.2795 9.98487 10.6402 10.3532C11.0008 10.7216 11.49 10.9286 12 10.9286C12.51 10.9286 12.9992 10.7216 13.3598 10.3532C13.7205 9.98487 13.9231 9.48525 13.9231 8.96429C13.9231 8.44332 13.7205 7.9437 13.3598 7.57533Z",
      fill: props.colorsReality[3],
      className: "innerBodyClosedShape",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const SmartTemplate = IconWrapper('smart-template', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M10.5008 14.5C10.0263 14.5 9.6217 14.4445 9.28716 14.3336C8.96041 14.2226 8.692 14.0932 8.48194 13.9452C8.27188 13.7899 8.11239 13.6493 8.00347 13.5236C7.89455 13.3978 7.82842 13.3202 7.80508 13.2906C7.64949 13.1056 7.55224 12.9392 7.51334 12.7913C7.48222 12.6433 7.50556 12.4954 7.58336 12.3474C7.66894 12.1995 7.80897 12.0368 8.00347 11.8592C8.18241 11.6965 8.35746 11.6077 8.52862 11.5929C8.69978 11.5707 8.86705 11.604 9.03043 11.6928C9.20158 11.7816 9.36496 11.911 9.52056 12.0811C9.70728 12.2809 9.86677 12.4177 9.99903 12.4917C10.1313 12.5583 10.283 12.5915 10.4542 12.5915C10.6642 12.5915 10.8354 12.5693 10.9676 12.525C11.0999 12.4732 11.1971 12.3992 11.2594 12.3031C11.3216 12.1995 11.3527 12.07 11.3527 11.9147C11.3527 11.789 11.2866 11.6928 11.1543 11.6262C11.0221 11.5522 10.847 11.4894 10.6292 11.4376C10.4191 11.3858 10.1819 11.3303 9.91734 11.2712C9.65282 11.2046 9.39219 11.1195 9.13545 11.016C8.97986 10.9568 8.82815 10.8828 8.68033 10.794C8.53251 10.7053 8.39247 10.6054 8.26021 10.4945C8.13573 10.3761 8.02681 10.2393 7.93345 10.0839C7.84009 9.92117 7.76619 9.73994 7.71173 9.54022C7.66505 9.3405 7.64171 9.11489 7.64171 8.86338C7.64171 8.41216 7.75841 8.00902 7.9918 7.65395C8.23298 7.29889 8.55974 7.0178 8.97208 6.81068C9.39219 6.60356 9.86677 6.5 10.3958 6.5C10.777 6.5 11.1038 6.52959 11.3761 6.58877C11.6484 6.64794 11.8701 6.71822 12.0413 6.79958C12.2202 6.88095 12.3563 6.95862 12.4497 7.03259C12.5431 7.09917 12.6014 7.14355 12.6248 7.16574C12.8815 7.38766 13.0215 7.57998 13.0449 7.74272C13.0682 7.89806 12.9749 8.12367 12.7648 8.41956C12.5314 8.73763 12.3019 8.91886 12.0763 8.96325C11.8507 9.00023 11.59 8.92996 11.2944 8.75243C11.2321 8.70804 11.1699 8.65996 11.1077 8.60818C11.0454 8.54901 10.9599 8.50092 10.8509 8.46394C10.7498 8.41956 10.5942 8.39736 10.3841 8.39736C10.3063 8.39736 10.2285 8.41216 10.1507 8.44175C10.0729 8.46394 10.0068 8.49723 9.95235 8.54161C9.89789 8.57859 9.85121 8.62668 9.81231 8.68585C9.78119 8.74503 9.76563 8.80791 9.76563 8.87448C9.76563 9.02982 9.82787 9.15187 9.95235 9.24064C10.0768 9.32201 10.2402 9.38488 10.4425 9.42926C10.6525 9.47365 10.8821 9.51803 11.131 9.56241C11.38 9.6068 11.6328 9.66597 11.8896 9.73994C12.0996 9.80652 12.3019 9.89159 12.4964 9.99515C12.6909 10.0987 12.862 10.2319 13.0099 10.3946C13.1577 10.5573 13.2744 10.7607 13.36 11.0049C13.4533 11.2416 13.5 11.5337 13.5 11.8814C13.5 12.3622 13.4028 12.7728 13.2083 13.113C13.0138 13.4459 12.7609 13.7159 12.4497 13.923C12.1463 14.1227 11.8195 14.267 11.4694 14.3558C11.1271 14.4519 10.8043 14.5 10.5008 14.5Z",
      fill: props.colorsReality[1],
      className: "body",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ', jsx("path", {
      d: "M7 17H4L4 4L17 4V7M7 17L17 17L17 7M7 17V20L20 20L20 7H17",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const PhotoPlus = IconWrapper('photo-plus', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M4 20L4 4L20 4L20 12M4 20H12M4 20L14 10L16 12",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("circle", {
      cx: "9",
      cy: "9",
      r: "1",
      fill: props.colorsReality[1],
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body"
    }), ' ', jsx("path", {
      d: "M18 21L18 18M18 15L18 18M18 18L21 18M18 18L15 18",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const UploadVideo = IconWrapper('upload-video', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M9 15V9M9 9L6 11.8715M9 9L12 11.8715",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M16 13L16 19L2 19L2 5L16 5L16 11M16 13L22 18L22 6L16 11M16 13L16 11",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const FileZip = IconWrapper('file-zip', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M20 21L4 21L4 3L20 3L20 21Z",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ', jsx("path", {
      d: "M11 14V15H13V14H11Z",
      fill: props.colorsReality[3],
      className: "innerBodyClosedShape",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ', jsx("path", {
      d: "M13 3V4M11 6V6.5M13 8V8.5M11 10V10.5M13 12V14M13 14V15H11V14H13Z",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      className: "innerBodyPath",
      strokeLinejoin: props.strokeLinejoin
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Download2 = IconWrapper('download-2', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M12 4V15M12 15L17 10.4876M12 15L7 10.4876",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M4 14L4 20L20 20L20 14",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Download1 = IconWrapper('download-1', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M12 4V16M12 16L19 9M12 16L5 9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M4 20H20",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const MapPin = IconWrapper('map-pin', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "12",
      cy: "10",
      r: "3",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyClosedShape",
      fill: props.colorsReality[3]
    }), ' ', jsx("path", {
      d: "M20 10C20 14.4183 16 18 12 22C8 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const World = IconWrapper('world', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ', jsx("path", {
      d: "M11.3583 12.9943L7.30505 19.6797L7.51723 12.6049L3.36743 9.44575C4.0585 7.10631 5.67468 5.16379 7.79235 4.04181L9.95483 6.16006L5.9845 10.0381L8.66216 12.9943H11.3583Z",
      fill: props.colorsReality[3],
      className: "innerBodyClosedShape",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ', jsx("path", {
      d: "M20.9999 11.9998C20.9999 11.326 20.9259 10.6695 20.7855 10.0381L16.7461 10.3509L15.5198 11.4503V13.776L19.0277 17.6225C20.2618 16.0821 20.9999 14.1271 20.9999 11.9998Z",
      fill: props.colorsReality[3],
      className: "innerBodyClosedShape",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ', jsx("path", {
      d: "M16.4501 6.27029L15.8475 3.86133C17.0904 4.44998 18.1769 5.31497 19.0277 6.37698L16.4501 6.27029Z",
      fill: props.colorsReality[3],
      className: "innerBodyClosedShape",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    }), ' ', jsx("path", {
      d: "M11.3583 12.9943L7.30505 19.6797L7.51723 12.6049L3.36743 9.44575C4.0585 7.10631 5.67468 5.16379 7.79235 4.04181L9.95483 6.16006L5.9845 10.0381L8.66216 12.9943H11.3583Z",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyClosedShape",
      fill: props.colorsReality[3]
    }), ' ', jsx("path", {
      d: "M20.9999 11.9998C20.9999 11.326 20.9259 10.6695 20.7855 10.0381L16.7461 10.3509L15.5198 11.4503V13.776L19.0277 17.6225C20.2618 16.0821 20.9999 14.1271 20.9999 11.9998Z",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyClosedShape",
      fill: props.colorsReality[3]
    }), ' ', jsx("path", {
      d: "M16.4501 6.27029L15.8475 3.86133C17.0904 4.44998 18.1769 5.31497 19.0277 6.37698L16.4501 6.27029Z",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyClosedShape",
      fill: props.colorsReality[3]
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const ExternalLink = IconWrapper('external-link', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M9 7H4V20H17V15",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M11 13L20 4M20 4H14M20 4V10",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Link = IconWrapper('link', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M9 15L15 9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M9.83745 5.51236L10.5583 4.79151C12.947 2.40283 16.8198 2.40283 19.2085 4.79151C21.5972 7.18019 21.5972 11.053 19.2085 13.4417L18.4876 14.1625M5.51236 9.83745L4.79151 10.5583C2.40283 12.947 2.40283 16.8198 4.79151 19.2085C7.18019 21.5972 11.053 21.5972 13.4417 19.2085L14.1625 18.4876",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const PlayCircle = IconWrapper('play-circle', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ', jsx("path", {
      d: "M10.7 14.5V9.5L14.45 12L10.7 14.5Z",
      fill: props.colorsReality[3],
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyClosedShape"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const PauseCircle = IconWrapper('pause-circle', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ', jsx("path", {
      d: "M10 14.5L10 9.5",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyPath"
    }), ' ', jsx("path", {
      d: "M14 14.5L14 9.5",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const HelpCircle = IconWrapper('help-circle', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ', jsx("path", {
      d: "M12 15.9902V16.0002",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyPath"
    }), ' ', jsx("path", {
      d: "M9.83643 9.82437C10.3277 8.07418 12.055 7.54113 13.3563 8.4086C14.6577 9.27607 14.9099 12.204 12.0002 12.5612L12.0002 13.3464",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const InfoCircle = IconWrapper('info-circle', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ', jsx("path", {
      d: "M12 7.99023V8.00024",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyPath"
    }), ' ', jsx("path", {
      d: "M12 16L12 12",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const AlertCircle = IconWrapper('alert-circle', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ', jsx("path", {
      d: "M12 15.9902V16.0002",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyPath"
    }), ' ', jsx("path", {
      d: "M12 12L12 8",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const CircleCheck = IconWrapper('circle-check', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ', jsx("path", {
      d: "M8 12L11 15L16 10",
      stroke: props.colorsReality[2],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "innerBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const ChevronsDown = IconWrapper('chevrons-down', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M5 3L12 9L19 3",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M5 9L12 15L19 9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M5 15L12 21L19 15",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const ArrowNarrowRight = IconWrapper('arrow-narrow-right', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M18 8L22 12M22 12L18 16M22 12H2",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const ChevronRight = IconWrapper('chevron-right', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M9 4L17 12L9 20",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const ChevronDown = IconWrapper('chevron-down', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M20 9L12 17L4 9",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Check = IconWrapper('check', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M3 11L10 18L21 6",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Dots = IconWrapper('dots', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "4",
      cy: "12",
      r: "1",
      fill: props.colorsReality[1],
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body"
    }), ' ', jsx("circle", {
      cx: "12",
      cy: "12",
      r: "1",
      fill: props.colorsReality[1],
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body"
    }), ' ', jsx("circle", {
      cx: "20",
      cy: "12",
      r: "1",
      fill: props.colorsReality[1],
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const DotsVertical = IconWrapper('dots-vertical', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("circle", {
      cx: "12",
      cy: "20",
      r: "1",
      fill: props.colorsReality[1],
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body"
    }), ' ', jsx("circle", {
      cx: "12",
      cy: "12",
      r: "1",
      fill: props.colorsReality[1],
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body"
    }), ' ', jsx("circle", {
      cx: "12",
      cy: "4",
      r: "1",
      fill: props.colorsReality[1],
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Plus = IconWrapper('plus', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M12 20L12 12M12 4L12 12M12 12L20 12M12 12L4 12",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const ArrowRight = IconWrapper('arrow-right', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M13.9155 5L21 12M21 12L13.9155 19M21 12H3",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const ArrowLeft = IconWrapper('arrow-left', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M10.0845 19L3 12M3 12L10.0845 5M3 12L21 12",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Pause = IconWrapper('pause', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M7 20L7 4",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("path", {
      d: "M17 20L17 4",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Play = IconWrapper('play', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M8 20V4L20 12L8 20Z",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Send = IconWrapper('send', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M6 12V20L20 12L6 4V12ZM6 12H10",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Success = IconWrapper('success', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M3 11L10 18L21 6",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Close = IconWrapper('close', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M5 19L12 12M19 5L12 12M12 12L19 19M12 12L5 5",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const ShoppingCart = IconWrapper('shopping-cart', true, props => {
  return jsxs("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [' ', jsx("path", {
      d: "M1 3H4L5 7M5 7L7 15H19L21 7H5Z",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "outBodyPath"
    }), ' ', jsx("circle", {
      cx: "9",
      cy: "20",
      r: "1",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ', jsx("circle", {
      cx: "17",
      cy: "20",
      r: "1",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin,
      className: "body",
      fill: props.colorsReality[1]
    }), ' ']
  }));
});

/* eslint-disable-next-line */
const Menu = IconWrapper('menu', true, props => {
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24"
  }, {
    children: jsx("path", {
      d: "M4 5h16M4 12h12M4 19h16",
      className: "outBodyPath",
      stroke: props.colorsReality[0],
      strokeWidth: props.strokeWidth,
      strokeLinecap: props.strokeLinecap,
      strokeLinejoin: props.strokeLinejoin
    })
  }));
});

export { AlertCircle, ArrowLeft, ArrowNarrowRight, ArrowRight, Check, ChevronDown, ChevronRight, ChevronsDown, CircleCheck, Close, CloudClips, Dots, DotsVertical, Download1, Download2, ExternalLink, FileZip, GestureControl, HelpCircle, InfoCircle, Link, LiveMasters, MapPin, Menu, PanoramicSplit, Pause, PauseCircle, PhotoPlus, Play, PlayCircle, Plus, Send, ShoppingCart, SmartHitchcock, SmartTemplate, SmartTracking, Success, UploadVideo, World, ZycamiEditor };
